import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';

import {usePanel} from '../../app/PanelProvider.js';

/**
 * Chave própria, e não um pedaço da chave do snapshot.
 *
 * O radar tem endpoint próprio e credencial própria: ele pode estar
 * `unavailable` com o resto do painel inteiro medido, e o contrário também.
 * Pendurar as duas leituras na mesma chave faria uma invalidar a outra sem
 * motivo, e faria a falta de credencial do radar recarregar a fila do dia.
 */
export const VIRAL_RADAR_KEY = ['radar', 'virais'] as const;

export const useViralRadar = () => {
  const {dataSource} = usePanel();
  return useQuery({
    queryKey: VIRAL_RADAR_KEY,
    queryFn: ({signal}) => dataSource.getViralRadar(signal),
  });
};

/**
 * Virar a tendência em pauta, e recarregar a lista depois.
 *
 * A invalidação é o que faz a linha passar a dizer "já virou pauta" sem
 * recarregar a página. Ela não é enfeite: sem ela, o botão continuaria de pé
 * sobre uma linha que a API não aceita mais, e o segundo clique voltaria com
 * `409` para uma ação que de fato deu certo.
 *
 * Não há atualização otimista aqui, de propósito. A criação da pauta acontece
 * na mesma transação que grava a prova `platform_api`, e a única coisa capaz
 * de dizer que ela existiu é a resposta do servidor. Marcar a linha antes
 * disso mostraria pauta criada onde o portão de fonte pode ter recusado.
 */
export const useCreateTrendTopic = () => {
  const {dataSource} = usePanel();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (viralPostId: string) =>
      dataSource.createTrendTopic(viralPostId),
    onSuccess: () => {
      void queryClient.invalidateQueries({queryKey: VIRAL_RADAR_KEY});
    },
  });
};
